// extracted by mini-css-extract-plugin
export default {"metricFacet":"mrmE4OrNTZEVQD_F9Ld_","metric":"EOf7vYVgVtvSVk2ZrSKH","topLine":"SnjDtO1AcibJAWpvQ3_n","total":"cf5WxiJ60_CQEWkcJIZz","label":"nIjG6NiJHvTEm0hnoZ74"};